import { Box, Center, Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { useTranslations } from "next-intl";
import Navbar from "../LandingPage/Navbar";
import heroBg from "@root/public/images/horizon.jpg";
import { ScheduleFreeDiscoveryCallButton } from "./ScheduleFreeDiscoveryCallButton";
import clarifayoLogo from "@root/public/images/logos/clarifayo-white-black.jpg";
import Image from "next/image";

export const CoacheeHero = () => {
  const t = useTranslations("CoacheePage");

  return (
    <Stack
      gap={{ base: 8, md: 14 }}
      pb={{ base: 8, md: 20 }}
      pt={{ base: 8, md: 32 }}
      px={{
        base: 8,
        md: 20,
      }}
      justifyContent={"flex-end"}
      bgColor="brand.1000"
      position="relative"
      overflow={"hidden"}
      h={{
        base: "90vh",
        md: "700px",
      }}
      backgroundImage={`url(${heroBg.src})`}
      backgroundSize="cover"
      backgroundPosition="bottom"
      backgroundAttachment="fixed"
    >
      <Box className="coachee-hero-bg"></Box>
      <Box position="absolute" top={0} left={0} w="full">
        <Navbar />
      </Box>

      <Stack
        direction={["column", "row"]}
        gap={16}
        alignItems={"flex-end"}
        w="full"
        zIndex={1}
      >
        <Box flex={1} maxW={{ base: "full", md: "50vw" }}>
          <Heading
            fontWeight={600}
            fontSize={{ base: "42px", md: "68px" }}
            textAlign={{ base: "center", md: "left" }}
            color="white"
            lineHeight={"1.1"}
            letterSpacing={".1rem"}
            fontFamily={`'Marlide', sans-serif`}
            mb={4}
          >
            <Text>{t("title")}</Text>
          </Heading>
          <Text
            fontSize={{ base: "18px", md: "22px" }}
            color="white"
            textAlign={{ base: "center", md: "left" }}
            maxW={{ base: "full", md: "48vw" }}
            dangerouslySetInnerHTML={{ __html: t.raw("subtitle") }}
            mb={6}
          />
          <ScheduleFreeDiscoveryCallButton label={t("firstCta")} />
        </Box>
        <Flex
          flex={1}
          w="full"
          alignItems={"flex-end"}
          h="full"
          justifyContent={"flex-end"}
        >
          <Box position="relative">
            {/* <Image
              src={clarifayoLogo}
              alt="Clarifayo Coaching"
              width={240}
              height={240}
              objectPosition="bottom"
              style={{ borderRadius: "12px" }}
            /> */}
          </Box>
        </Flex>
      </Stack>
    </Stack>
  );
};
